import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import VModal from 'vue-js-modal';
import VueMask from 'v-mask';
import Vue2TouchEvents from 'vue2-touch-events';
import App from './App.vue';
import store from './store';
import api from './api';
import calculateService from './services/calculateService';
import availableDateService from './services/availableDateService';
import statisticService from './services/statisticService';
import prefetchCity from './services/prefetchCity';
import i18n from './translation';

import 'moment/locale/ru';

import './assets/main.scss';

Vue.use(api, {
  baseURL: '/',
});

Vue.use(calculateService);
Vue.use(availableDateService);
Vue.use(statisticService);
Vue.use(prefetchCity);
Vue.use(Vue2TouchEvents);

Vue.use(VueScrollTo);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueMask);
Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
